import BoxsSkeleton from '../BoxSkeleton/BoxSkeleton';

import './ClaimsSkeleton.css';

export default function ClaimsSkeleton() {
	return (
		<div id="claims-skeleton" className="skeleton">
			<h3 className="skeleton-element" />
			<div className="box-grid">
				<BoxsSkeleton />
				<BoxsSkeleton />
			</div>
		</div>
	);
}
